define('model/reminder-frequency.model',['require','exports','module','underscore','fukit'],function(require, exports, module) {
  // prettier-ignore
  var _         = require('underscore'),
      BaseModel = require('fukit').BaseModel;

  var ReminderFrequencyModel = BaseModel.extend({
    radioRequests: {
      'models ReminderFrequencyModel': '@constructor',
    },
    urlRoot: '/api/v2/coi/reminderFrequency',

    defaults: {
      displayName: 'No email reminders from Cayuse COI',
      reminderTypeId: null,
    },
  });

  ReminderFrequencyModel.CampaignPeriodCollection = ReminderFrequencyModel.Collection.extend({
    filters: [
      {
        field: 'reminder_type_id',
        value: 0,
      },
    ],
  });

  ReminderFrequencyModel.FinalizedCollection = ReminderFrequencyModel.Collection.extend({
    filters: [
      {
        field: 'reminderTypeId',
        value: 1,
      },
    ],
  });

  module.exports = ReminderFrequencyModel;
});

